// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3F3GC","additionalInfo":"AgreementModal_additionalInfo__24WQ8"};